// Temporary change to trigger localization pipeline 0.6

// Don't add any TypeScript things, because this file would be converted to .mjs in CI
export const en_US = {
  'ADD_CHAPTER_BUTTON.HEADER_TEXT': 'Create chapter',
  'ADD_CHAPTER_BUTTON.LABEL_TEXT': 'Chapter title',
  'ADD_CHAPTER_BUTTON.PLACEHOLDER_TEXT': 'Enter a title for your chapter',
  'ADD_CHAPTER_BUTTON.BUTTON_TEXT': 'Add chapter',

  'CHAPTER_DROPDOWN.EDIT_TITLE_OPTION': 'Edit title',
  'CHAPTER_DROPDOWN.DELETE_CHAPTER_OPTION': 'Delete chapter',

  'EDIT_CHAPTER_TITLE_MODAL.HEADER_TEXT': 'Edit chapter title',
  'EDIT_CHAPTER_TITLE_MODAL.LABEL_TEXT': 'Chapter title',
  'EDIT_CHAPTER_TITLE_MODAL.PLACEHOLDER_TEXT': 'Enter a title for your chapter',

  'CREATE_PAGE_MODAL.HEADER_TEXT': 'Create page',
  'CREATE_PAGE_MODAL.LABEL_TEXT': 'Page title',
  'CREATE_PAGE_MODAL.PLACEHOLDER_TEXT': 'Enter a title for your page',

  'DELETE_CHAPTER_MODAL.HEADER_TEXT': 'Delete chapter',
  'DELETE_CHAPTER_MODAL.CONTENT_TEXT':
    'Are you sure you want to delete "{title}". Deleting this chapter will also delete all the pages inside. This action cannot be undone.',
  'DELETE_CHAPTER_MODAL.BUTTON_TEXT': 'Delete chapter',

  'EMPTY_SEARCH_RESULTS.IMG_ALT': 'Empty Search Results',
  'EMPTY_SEARCH_RESULTS.HEADER_TEXT': 'No results to show',
  'EMPTY_SEARCH_RESULTS.PARAGRAPH_TEXT':
    "We couldn't find any match for the search term '{searchTerm}'.",
  'FORBIDDEN.IMG_ALT': 'Forbidden',
  'FORBIDDEN.HEADER_TEXT': 'Unable to access the guide',
  'FORBIDDEN.HEADER_TEXT_PAGE': 'Unable to access the page',
  'FORBIDDEN.PARAGRAPH_TEXT':
    'You do not have access to the guide. Please contact your administrator or go back to Guidelines overview.',
  'FORBIDDEN.PARAGRAPH_TEXT_PAGE':
    'You do not have access to this page. Please contact your administrator or go back to Guidelines overview.',
  'FORBIDDEN.BUTTON_TEXT': 'Go to overview',

  'GUIDE_NOT_FOUND.IMG_ALT': 'Not found',
  'GUIDE_NOT_FOUND.HEADER_TEXT': 'Guide not found',
  'GUIDE_NOT_FOUND.PARAGRAPH_TEXT':
    'Unfortunately, the guide you are looking for cannot be found. You can go back to your overview and start over.',
  'GUIDE_NOT_FOUND.BUTTON_TEXT': 'Back to overview',

  'GUIDE_PAGE_NOT_FOUND.IMG_ALT': 'Not found',
  'GUIDE_PAGE_NOT_FOUND.HEADER_TEXT': 'Page not found',
  'GUIDE_PAGE_NOT_FOUND.PARAGRAPH_TEXT':
    'Unfortunately, the page you are looking for cannot be found. You can use the sidebar to try another page or go back to the overview.',
  'GUIDE_PAGE_NOT_FOUND.BUTTON_TEXT': 'Back to overview',

  'INTERNAL_SERVER_ERROR.IMG_ALT': 'Internal Server Error',
  'INTERNAL_SERVER_ERROR.HEADER_TEXT': 'Unable to complete the request',
  'INTERNAL_SERVER_ERROR.PARAGRAPH_TEXT':
    'We are aware of the error, and we are working to fix it. In the meantime, you may refresh your browser or go back to Guidelines overview.',
  'INTERNAL_SERVER_ERROR.BUTTON_TEXT': 'Go to overview',
  'INTERNAL_SERVER_ERROR.REFRESH_BUTTON_TEXT': 'Go to overview',

  'UNAUTHORIZED.IMG_ALT': 'Unauthorized',
  'UNAUTHORIZED.HEADER_TEXT': 'No guide access',
  'UNAUTHORIZED.PARAGRAPH_TEXT_1':
    'You don’t have access to the guide content. Please contact your admin to request access or go back to the guide overview.',
  'UNAUTHORIZED.BUTTON_TEXT': 'Go to overview',
  'UNAUTHORIZED.HEADER_TEXT_2': 'No access',
  'UNAUTHORIZED.PARAGRAPH_TEXT_2':
    'You don’t have permissions to view this page. Please contact your admin to request Brand Guidelines access.',
  'UNAUTHORIZED.GROUP_HEADER_TEXT': 'No group access',
  'UNAUTHORIZED.GROUP_PARAGRAPH_TEXT_1':
    'You do not have access to the group. Please contact your administrator or go back to Guidelines overview.',

  'ACCESS_MODAL.HEADER_TEXT': 'Share {title}',

  'ACCESS_MODAL.MODAL_ACTIONS_SAVE_BUTTON_TEXT': 'Save changes',
  'ACCESS_MODAL.MODAL_ACTIONS_SAVING_BUTTON_TEXT': 'Saving...',
  'ACCESS_MODAL.MODAL_ACTIONS_CANCEL_BUTTON_TEXT': 'Cancel',

  'ACCESS_MODAL_DROPDOWN.BUTTON_TEXT': 'Change',
  'ACCESS_MODAL_DROPDOWN.RESTRICTED_OPTION': 'Restricted',
  'ACCESS_MODAL_DROPDOWN.PORTAL_USERS_OPTION': 'All users',
  'ACCESS_MODAL_DROPDOWN.PUBLIC_OPTION': 'Public',
  'ACCESS_MODAL_DROPDOWN.SPECIFIC_STATE_DESCRIPTION_TEXT':
    'Only users added to this {document} can access',
  'ACCESS_MODAL_DROPDOWN.PORTAL_STATE_DESCRIPTION_TEXT':
    'All CX UC users can access',
  'ACCESS_MODAL_DROPDOWN.PORTAL_STATE_DESCRIPTION_TEXT_HOMEPAGE':
    'All portal users can access',
  'ACCESS_MODAL_DROPDOWN.PORTAL_STATE_LIMITED_DESCRIPTION_TEXT':
    'Only available in guides shared with all users',
  'ACCESS_MODAL_DROPDOWN.PUBLIC_STATE_DESCRIPTION_TEXT':
    'Anyone with the link can access',
  'ACCESS_MODAL_DROPDOWN.PUBLIC_STATE_LIMITED_DESCRIPTION_TEXT':
    'Only available in guides shared publicly',
  'ACCESS_MODAL_DROPDOWN.PRIVATE_STATE_DESCRIPTION_TEXT': 'Only you can access',

  'ACCESS_MODAL_SEARCH.PLACEHOLDER_TEXT':
    'Search for users, groups or profiles to add',
  'ACCESS_MODAL_SEARCH.NO_RESULTS': 'No results',
  'ACCESS_MODAL_SEARCH.LIMIT_RECIPIENTS_TEXT':
    'Max 30 recipients. Use groups or profiles for larger sharing.',

  'ACCESS_LIST.HEADER_TEXT': 'Who has access',
  'ACCESS_LIST.OWNER_TEXT': 'Owner',
  'ACCESS_LIST.AUTHOR_UNKNOWN': 'Former user (deleted)',
  'ACCESS_LIST.USER_UNKNOWN': 'Former user (deleted)',
  'ACCESS_LIST_ITEM.MODAL_VIEWER': 'Viewer',
  'ACCESS_LIST_ITEM.MODAL_EDITOR': 'Editor',
  'ACCESS_LIST_ITEM.MODAL_REMOVE': 'Remove',

  'AUDIO_WIDGET_MODAL.HEADER': 'Audio widget',
  'AUDIO_WIDGET_MODAL.IMG_ALT': 'No Permissions',
  'AUDIO_WIDGET_MODAL.TITLE': 'Unable to add any audio files',
  'AUDIO_WIDGET_MODAL.DESCRIPTION_1':
    'Your account settings do not allow you to add any audio files.',
  'AUDIO_WIDGET_MODAL.DESCRIPTION_2':
    'Please contact your administrator to enable access.',
  'AUDIO_WIDGET_MODAL.BUTTON_TEXT': 'Close',

  'COMMAND_ERROR_MODAL.CREATE_ACTION_TEXT': 'creating guide',
  'COMMAND_ERROR_MODAL.CREATE_ACTION_MESSAGE': 'create',
  'COMMAND_ERROR_MODAL.RENAME_GUIDE_TEXT': 'renaming guide',
  'COMMAND_ERROR_MODAL.RENAME_GUIDE_MESSAGE': 'rename',
  'COMMAND_ERROR_MODAL.DELETE_GUIDE_TEXT': 'deleting guide',
  'COMMAND_ERROR_MODAL.DELETE_GUIDE_MESSAGE': 'delete',
  'COMMAND_ERROR_MODAL.UPDATE_VISIBILITY_GUIDE_TEXT':
    'updating guide visibility',
  'COMMAND_ERROR_MODAL.UPDATE_VISIBILITY_GUIDE_MESSAGE':
    'update the guide visibility',
  'COMMAND_ERROR_MODAL.ADD_CHAPTER_TO_GUIDE_TEXT': 'creating chapter',
  'COMMAND_ERROR_MODAL.ADD_CHAPTER_TO_GUIDE_MESSAGE': 'create',
  'COMMAND_ERROR_MODAL.EDIT_CHAPTER_TITLE_TEXT': 'renaming chapter',
  'COMMAND_ERROR_MODAL.EDIT_CHAPTER_TITLE_MESSAGE': 'rename',
  'COMMAND_ERROR_MODAL.DELETE_CHAPTER_TEXT': 'deleting chapter',
  'COMMAND_ERROR_MODAL.DELETE_CHAPTER_MESSAGE': 'delete',
  'COMMAND_ERROR_MODAL.ADD_PAGE_TEXT': 'creating page',
  'COMMAND_ERROR_MODAL.ADD_PAGE_MESSAGE': 'adding',
  'COMMAND_ERROR_MODAL.DELETE_PAGE_TEXT': 'deleting page',
  'COMMAND_ERROR_MODAL.DELETE_PAGE_MESSAGE': 'delete',
  'COMMAND_ERROR_MODAL.EDIT_PAGE_TITLE_TEXT': 'renaming page',
  'COMMAND_ERROR_MODAL.EDIT_PAGE_TITLE_MESSAGE': 'rename',
  'COMMAND_ERROR_MODAL.DELETE_SECTION_TEXT': 'deleting section',
  'COMMAND_ERROR_MODAL.DELETE_SECTION_MESSAGE': 'delete the section',
  'COMMAND_ERROR_MODAL.DELETE_WIDGET_TEXT': 'deleting widget',
  'COMMAND_ERROR_MODAL.DELETE_WIDGET_MESSAGE': 'delete the widget',
  'COMMAND_ERROR_MODAL.MODAL_HEADER': 'Error {message}',
  'COMMAND_ERROR_MODAL.MODAL_CONTENT':
    ' We are unable to {message}. Please refresh and try again.',
  'COMMAND_ERROR_MODAL.BUTTON_TEXT': 'Refresh',

  'CREATE_GROUP_MODAL.DEFAULT_HEADER_TEXT': 'Group details',
  'CREATE_GROUP_MODAL.DEFAULT_BUTTON_TEXT': 'Create',
  'CREATE_GROUP_MODAL.INPUT_LABEL': 'Name',
  'CREATE_GROUP_MODAL.INPUT_PLACEHOLDER': 'Enter a name',
  'CREATE_GROUP_MODAL.TEXTAREA_LABEL': 'Description',
  'CREATE_GROUP_MODAL.TEXTAREA_ADDITIONAL_LABEL': '(Optional)',
  'CREATE_GROUP_MODAL.TEXTAREA_PLACEHOLDER': 'Enter a description',
  'CREATE_GROUP_MODAL.CANCEL_BUTTON_TEXT': 'Cancel',

  'MOVE_PAGE_MODAL.DEFAULT_HEADER_TEXT': 'Duplicate ‘{pageTitle}’ page',
  'MOVE_PAGE_MODAL.DEFAULT_SUBTITLE_TEXT':
    'Please select the new location of the duplicate page',
  'MOVE_PAGE_MODAL.GUIDE_INPUT_LABEL': 'Guide',
  'MOVE_PAGE_MODAL.GUIDE_INPUT_DESCRIPTION':
    'Anyone that has access to selected guide will be able to access this page unless you specify otherwise.',
  'MOVE_PAGE_MODAL.CHAPTER_INPUT_LABEL': 'Chapter',
  'MOVE_PAGE_MODAL.SWITCH_LABEL': 'Duplicate and move',
  'MOVE_PAGE_MODAL.SWITCH_DESCRIPTION':
    'You can’t move the original page to another guide because you don’t have permission to delete pages in this guide.',
  'MOVE_PAGE_MODAL.DEFAULT_BUTTON_TEXT': 'Duplicate',
  'MOVE_PAGE_MODAL.LOADING_BUTTON_TEXT': 'Duplicating',
  'MOVE_PAGE_MODAL.CANCEL_BUTTON_TEXT': 'Cancel',

  'CREATE_MODAL.DEFAULT_BUTTON_LABEL': 'Create',
  'CREATE_MODAL.CANCEL_BUTTON_LABEL': 'Cancel',

  'CREATE_MODAL.NEW_GUIDE_HEADER_TEXT': 'New guide',
  'CREATE_MODAL.NEW_GUIDE_PAGE_HEADER_TEXT': 'New page',
  'CREATE_MODAL.NEW_GROUP_HEADER_TEXT': 'New group',
  'CREATE_MODAL.NEW_PAGE_HEADER_TEXT': 'New landing page',
  'CREATE_MODAL.NEW_HOMEPAGE_HEADER_TEXT': 'New Homepage',
  'CREATE_MODAL.LANDING_PAGE.CARD_TITLE': 'Landing page',
  'CREATE_MODAL.NEW_GUIDE_BUTTON_TEXT': 'Multi-page layout',
  'CREATE_MODAL.NEW_GROUP_BUTTON_TEXT':
    'Organize content by shared traits such as brands or markets',
  'CREATE_MODAL.NEW_PAGE_BUTTON_TEXT': 'Single-page layout',

  'DELETE_MODAL.CANCEL_BUTTON_TEXT': 'Cancel',
  'DELETE_MODAL.DELETE_BUTTON_TEXT': 'Delete',

  'SHARE_MODAL.DEFAULT_TOAST_LABEL': 'Copy link',
  'SHARE_MODAL.SUCCESS_TOAST_LABEL': 'Copied!',
  'SHARE_MODAL.FAILURE_TOAST_LABEL': 'Failed to copy to clipboard',
  'SHARE_MODAL.BUTTON_TEXT': 'Copy link',
  'SHARE_MODAL.ACTION_BUTTON_TEXT': 'Done',

  'TABLE_OF_CONTENTS_MODAL.MODAL_TITLE': 'Table of Contents',
  'TABLE_OF_CONTENTS_MODAL.SIDEBAR_TEXT': 'Sidebar',
  'TABLE_OF_CONTENTS_MODAL.SIDEBAR_DESCRIPTION':
    'Show table of contents in sidebar',
  'TABLE_OF_CONTENTS_MODAL.PAGE_TEXT': 'Page',
  'TABLE_OF_CONTENTS_MODAL.PAGE_DESCRIPTION': 'Show table of contents in page',
  'TABLE_OF_CONTENTS_MODAL.CANCEL_BUTTON_TEXT': 'Cancel',
  'TABLE_OF_CONTENTS_MODAL.SAVE_BUTTON_TEXT': 'Save',

  'UNSAVED_CHANGES_MODAL.HEADER_TEXT': 'Unsaved Changes',
  'UNSAVED_CHANGES_MODAL.CONTENT_TEXT':
    'Are you sure you want to leave the page?',
  'UNSAVED_CHANGES_MODAL.CANCEL_BUTTON_TEXT': 'Cancel',
  'UNSAVED_CHANGES_MODAL.LEAVE_BUTTON_TEXT': 'Leave Page',

  'UPLOAD_IN_PROGRESS_MODAL.TITLE': 'Cancel upload',
  'UPLOAD_IN_PROGRESS_MODAL.PRIMARY_BUTTON_TEXT': 'Back to page',
  'UPLOAD_IN_PROGRESS_MODAL.SECONDARY_BUTTON_TEXT': 'Proceed anyway',
  'UPLOAD_IN_PROGRESS_MODAL.CONTENT':
    'If you move out of this page the upload will be canceled. Are you sure you want to cancel the upload?',

  'USE_MODAL.OFFLINE_MODAL_TITLE': 'No Internet connection',
  'USE_MODAL.OFFLINE_MODAL_COPY': 'You are offline. Trying to reconnect...',
  'USE_MODAL.OFFLINE_MODAL_BUTTON_TEXT': 'Refresh',

  'GROUP_KEBAB_MENU.EDIT_TITLE_ITEM': 'Edit title',
  'GROUP_KEBAB_MENU.EDIT_TITLE_HEADER_TEXT': 'Edit group title',
  'GROUP_KEBAB_MENU.EDIT_TITLE_LABEL': 'Group title',
  'GROUP_KEBAB_MENU.EDIT_TITLE_PLACEHOLDER': 'Enter a title for your group',
  'GROUP_KEBAB_MENU.EDIT_TITLE_BUTTON_TEXT': 'Save',
  'GROUP_KEBAB_MENU.EDIT_DESCRIPTION_ITEM': 'Edit description',
  'GROUP_KEBAB_MENU.EDIT_DESCRIPTION_HEADER': 'Edit group description',
  'GROUP_KEBAB_MENU.EDIT_DESCRIPTION_LABEL': 'Group description',
  'GROUP_KEBAB_MENU.EDIT_DESCRIPTION_PLACEHOLDER':
    'Enter a description for your group',
  'GROUP_KEBAB_MENU.EDIT_DESCRIPTION_BUTTON_TEXT': 'Save',
  'GROUP_KEBAB_MENU.SET_COVER_ITEM': 'Set cover',
  'GROUP_KEBAB_MENU.REMOVE_COVER_ITEM': 'Remove cover',
  'GROUP_KEBAB_MENU.EDIT_COVER_ITEM': 'Edit cover',
  'GROUP_KEBAB_MENU.CROP_COVER_ITEM': 'Crop',
  'GROUP_KEBAB_MENU.RESET_CROP_COVER_ITEM': 'Reset crop',
  'GROUP_KEBAB_MENU.DELETE_ITEM': 'Delete',
  'GROUP_KEBAB_MENU.GROUP_ACCESS_ITEM': 'Share',
  'GROUP_KEBAB_MENU.DELETE_HEADER_TEXT': 'Delete group',
  'GROUP_KEBAB_MENU.DELETE_CONTEXT_TEXT':
    'Are you sure you want to delete "{title}"? Deleting this group will delete access permissions set at group level and all the guides that belong it will be moved to Overview page. This action cannot be undone. ',
  'GROUP_OVERVIEW.EMPTY_OVERVIEW_HEADER': 'No groups to see here',
  'GROUP_OVERVIEW.EMPTY_OVERVIEW_HEADER_V2': 'No content yet',
  'GROUP_OVERVIEW.EMPTY_OVERVIEW_SUBTITLE':
    'Create new group to organize content by shared traits such as brands or markets',
  'GROUP_OVERVIEW.EMPTY_OVERVIEW_SUBTITLE_V2':
    'Looks like there’s nothing here! Explore the Guides and Landing page examples for some inspiration.',
  'GROUP_DETAILS_OVERVIEW.EMPTY_OVERVIEW_HEADER': 'No guides to see here',
  'GROUP_DETAILS_OVERVIEW.EMPTY_OVERVIEW_SUBTITLE':
    'Create a new guide and add it to this group or move an existing guide from the overview to this group',

  'GUIDE_GRID.LABEL':
    '{count, plural, one {{count} guide} other {{count} guides}}',
  'GROUP_GRID.LABEL':
    '{count, plural, one {{count} group} other {{count} groups}}',
  'PAGE_GRID.LABEL':
    '{count, plural, one {{count} landing page} other {{count} landing pages}}',

  'GUIDE_KEBAB_MENU.VIEW_LIVE_ITEM': 'View live version',
  'GUIDE_KEBAB_MENU.EDIT_TITLE_ITEM': 'Edit title',
  'GUIDE_KEBAB_MENU.GUIDE_ACCESS_ITEM': 'Share',
  'GUIDE_KEBAB_MENU.REMOVE_FEATURE_ITEM': 'Remove from Featured',
  'GUIDE_KEBAB_MENU.ADD_FEATURE_ITEM': 'Add to Featured',
  'GUIDE_KEBAB_MENU.SUBMENU_TITLE': 'Move to group',
  'GUIDE_KEBAB_MENU.EMPTY_GROUPS_TEXT': 'No groups available',
  'GUIDE_KEBAB_MENU.REMOVE_FROM_GROUP_ITEM': 'Remove from {group}',
  'GUIDE_KEBAB_MENU.SET_COVER_ITEM': 'Set cover',
  'LANDING_PAGE_KEBAB_MENU.SET_COVER_ITEM': 'Set cover',
  'GUIDE_KEBAB_MENU.REMOVE_COVER_ITEM': 'Remove cover',
  'LANDING_PAGE_KEBAB_MENU.REMOVE_COVER_ITEM': 'Remove cover',
  'GUIDE_KEBAB_MENU.EDIT_COVER_ITEM': 'Edit cover',
  'GUIDE_KEBAB_MENU.CROP_COVER_ITEM': 'Crop',
  'GUIDE_KEBAB_MENU.RESET_CROP_COVER_ITEM': 'Reset crop',
  'GUIDE_KEBAB_MENU.DELETE_ITEM': 'Delete',
  'GUIDE_KEBAB_MENU.DELETE_ITEM_PAGE': 'Delete',
  'GUIDE_KEBAB_MENU.DELETE_TOOLTIP_CONTENT':
    'Remove guide from group to delete',
  'GUIDE_KEBAB_MENU.DISABLED_DELETE_ITEM': 'Delete guide',
  'GUIDE_KEBAB_MENU.THEMESETS_ALT': 'Themes',
  'GUIDE_KEBAB_MENU.THEMESETS_ITEM': 'Themes',
  'GUIDE_KEBAB_MENU.CHANGE_THEME': 'Change theme',
  'GUIDE_KEBAB_MENU.DUPLICATE_ITEM': 'Duplicate',
  'GUIDE_KEBAB_MENU.SET_HOMEPAGE_ITEM': 'Set as homepage',
  'GUIDE_KEBAB_MENU.UNSET_HOMEPAGE_ITEM': 'Unset as homepage',
  'GUIDE_KEBAB_MENU.HOMEPAGE_REMOVAL': 'Cannot remove active homepage',

  'CROPPER_KEBAB_MENU.CROP': 'Crop',
  'CROPPER_KEBAB_MENU.RESET_CROP': 'Reset crop',
  'CROPPER_KEBAB_MENU.DELETE': 'Delete',

  'EDIT_GUIDE_MODAL.HEADER_TEXT': 'Edit guide title',
  'EDIT_GUIDE_MODAL.HEADER_TEXT_PAGE': 'Edit landing page title',
  'EDIT_GUIDE_MODAL.HEADER_TEXT_HOMEPAGE': 'Edit homepage title',
  'EDIT_GUIDE_MODAL.LABEL_TEXT': 'Guide title',
  'EDIT_GUIDE_MODAL.LABEL_TEXT_PAGE': 'Landing page title',
  'EDIT_GUIDE_MODAL.LABEL_TEXT_HOMEPAGE': 'Homepage title',
  'EDIT_GUIDE_MODAL.PLACEHOLDER_TEXT': 'Enter a title for your guide',
  'EDIT_GUIDE_MODAL.PLACEHOLDER_TEXT_PAGE':
    'Enter a title for your landing page',
  'EDIT_GUIDE_MODAL.PLACEHOLDER_TEXT_HOMEPAGE':
    'Enter a title for your homepage',

  'DELETE_GUIDE_MODAL.HEADER_TEXT': ' Delete guide',
  'DELETE_GUIDE_MODAL.HEADER_TEXT_PAGE': ' Delete landing page',
  'DELETE_GUIDE_MODAL.HEADER_TEXT_HOMEPAGE': ' Delete homepage',
  'DELETE_GUIDE_MODAL.BUTTON_TEXT': ' Delete guide',
  'DELETE_GUIDE_MODAL.BUTTON_TEXT_PAGE': ' Delete landing page',
  'DELETE_GUIDE_MODAL.BUTTON_TEXT_HOMEPAGE': ' Delete homepage',
  'DELETE_GUIDE_MODAL.CHECKBOX_1_TEXT':
    ' I understand all work will be destroyed',
  'DELETE_GUIDE_MODAL.CHECKBOX_2_TEXT':
    'I understand this action cannot be undone',
  'DELETE_GUIDE_MODAL.CONTENT_TEXT':
    'Are you sure you want to delete "{title}"? Deleting this guide will also delete all the chapters and pages inside. This action cannot be undone. ',
  'DELETE_GUIDE_MODAL.CONTENT_TEXT_PAGE':
    'Are you sure you want to delete "{title}"? This action cannot be undone. ',

  'DELETE_GROUP_MODAL.CHECKBOX_1_TEXT':
    'I understand all the guides will be moved to the overview page',
  'DELETE_GROUP_MODAL.CHECKBOX_2_TEXT':
    ' I understand this action cannot be undone',
  'DELETE_GROUP_MODAL.BUTTON_TEXT': 'Delete group',
  'THEMESET_KEBAB_MENU.EDIT_ITEM': 'Edit details',
  'THEMESET_KEBAB_MENU.DUPLICATE_ITEM': 'Duplicate',
  'THEMESET_KEBAB_MENU.DELETE_ITEM': 'Delete',

  'THEMESET_OVERVIEW.TITLE': 'Themes',

  'CREATE_GUIDE_MODAL.HEADER_TEXT': 'Create guide',
  'CREATE_GUIDE_MODAL.LABEL_TEXT': 'Guide title',
  'CREATE_GUIDE_MODAL.PLACEHOLDER_TEXT': 'Enter a title for your guide',
  'CREATE_GUIDE_MODAL.BUTTON_TEXT': 'New guide',

  'EMPTY_OVERVIEW_LOGO.IMG_ALT': 'Empty Overview Logo',

  'OVERVIEW_SIDEBAR.HOMEPAGE_TITLE': 'Homepages',
  'OVERVIEW.INSPIRATION_BUTTON_TEXT': 'Get inspiration',
  'OVERVIEW.EMPTY_HEADER_CREATE': 'Create a guide in seconds',
  'OVERVIEW.PAGES_EMPTY_HEADER_CREATE': 'Create a page in seconds',
  'OVERVIEW.PAGES_SUBTITLE_CREATE':
    "It takes 60 seconds or less to create a page. Don't worry, the page will only be visible to you at first.",
  'OVERVIEW.PAGES_EMPTY_HEADER': 'No guides yet',
  'OVERVIEW.SUBTITLE_CREATE':
    "It takes 60 seconds or less to create a guide. Don't worry, the guide will only be visible to you at first.",
  'OVERVIEW.EMPTY_HEADER': 'No guides yet',
  'OVERVIEW.EMPTY_HEADER_LANDING_PAGES': 'No landing pages yet',
  'OVERVIEW.LOADING_PAGE_COPY': 'Creating new guide...',
  'OVERVIEW.LOADING_LANDING_PAGE_COPY': 'Creating new landing page...',
  'OVERVIEW.LOADING_HOMEPAGE_COPY': 'Creating new homepage...',
  'OVERVIEW.CREATING_GROUP_COPY': 'Creating new group...',
  'OVERVIEW.FEATURED_GRID_TITLE': 'Featured',
  'OVERVIEW.GROUPS_GRID_TITLE': 'Groups',
  'OVERVIEW.GUIDES_GRID_TITLE': 'Guides',
  'OVERVIEW.MORE_GRID_TITLE': 'More',
  'OVERVIEW.PAGES_GRID_TITLE': 'Landing pages',
  'OVERVIEW.ALL_CONTENT_GRID_TITLE': 'All content',
  'OVERVIEW.EMPTY_HEADER_ALL_CONTENT': 'No content yet',
  'OVERVIEW.EMPTY_VIEWER_SUBTITLE_ALL_CONTENT': 'There’s nothing here yet, but feel free to explore once content is available!',
  'OVERVIEW.EMPTY_SUBTITLE_ALL_CONTENT':
    "Looks like there's nothing here! Explore the Guidelines and Landing page examples for some inspiration.",
  'OVERVIEW.NEW_ENTITY_BUTTON': 'New',
  'OVERVIEW.NEW_GROUP_BUTTON_TEXT': 'Group',
  'OVERVIEW.NEW_GUIDE_BUTTON_TEXT': 'Guide',
  'OVERVIEW.NEW_PAGE_BUTTON_TEXT': 'Landing page',
  'OVERVIEW.NEW_HOMEPAGE_BUTTON_TEXT': 'Homepage',
  'OVERVIEW.NEW_LINK_BUTTON_TEXT': 'Custom link',

  'OVERVIEW.WHATS_NEW_BUTTON': "See What's New",
  'OVERVIEW.SIDEBAR_GROUPS_TITLE': 'Groups',
  'OVERVIEW.SIDEBAR_GUIDES_TITLE': 'Guides',
  'OVERVIEW.SIDEBAR_PAGES_TITLE': 'Landing pages',
  'OVERVIEW.SIDEBAR_THEMES_TITLE': 'Themes',
  'OVERVIEW.SIDEBAR_LINKS_TITLE': 'Custom links',
  'OVERVIEW.SIDEBAR_PLAN_BADGE': 'Plan',
  'OVERVIEW.SIDEBAR_NEW_BADGE': 'New',
  'OVERVIEW.SIDEBAR_ALL_TITLE': 'All content',

  'OVERVIEW_ACTIONS.EDIT_ITEM': 'Edit Details',
  'OVERVIEW_ACTIONS.THEME_SETS_ITEM': 'Themes',
  'OVERVIEW_ACTIONS.CREATE_GROUP_ITEM': 'New group',
  'OVERVIEW_ACTIONS.IMG_ALT': 'Themes',

  'OVERVIEW_HEADER.ORDER_TITLE_LABEL': 'Name',
  'OVERVIEW_HEADER.ORDER_TITLE_CREATION_TIME': 'Date created',
  'OVERVIEW_HEADER.ORDER_TITLE_UPDATE_TIME': 'Date update',
  'OVERVIEW_HEADER.TITLE_TEXT': 'Guides',
  'OVERVIEW_HEADER.NEW_GUIDE_BUTTON_TEXT': 'New guide',
  'OVERVIEW_HEADER.NEW_GROUP_BUTTON_TEXT': 'New group',
  'OVERVIEW_HEADER.NEW_PAGE_BUTTON_TEXT': 'New landing page',
  'OVERVIEW_HEADER.NEW_LINK_BUTTON_TEXT': 'New link',
  'OVERVIEW_HEADER.SETTINGS_TOOLTIP_CONTENT': 'Guidelines settings',
  'OVERVIEW_HEADER.SORT_DIRECTION_LABEL_ASCENDING': 'Ascending',
  'OVERVIEW_HEADER.SORT_DIRECTION_LABEL_DESCENDING': 'Descending',
  'OVERVIEW_HEADER.GRID_VIEW_TOOLTIP_CONTENT': 'Grid view',
  'OVERVIEW_HEADER.LIST_VIEW_TOOLTIP_CONTENT': 'List view',
  'OVERVIEW_HEADER.SEARCH_FOR': 'Search guidelines content...',
  'OVERVIEW_HEADER.NEW_THEMESET_BUTTON_TEXT': 'New theme',
  'OVERVIEW_LIST_ELEMENT.CREATED_DATE_TEXT': 'Created {date}',
  'OVERVIEW_LIST_ELEMENT.EDITED_DATE_TEXT': 'Edited {date}',

  'OVERVIEW_CARD_MUTATION_MESSAGE.UPDATING_ACCESS': 'Updating access...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.RENAMING_GUIDE': 'Renaming guide...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.FEATURING_GUIDE': 'Featuring guide...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.UNFEATURING_GUIDE':
    'Removing from featured...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.SET_COVER': 'Editing cover...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.DELETE_GUIDE': 'Deleting guide...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.GUIDE_ADD_TO_GROUP': 'Adding to group...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.GUIDE_REMOVE_FROM_GROUP':
    'Removing from group...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.DUPLICATE_GUIDE': 'Duplicating {type}...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.RENAMING_GROUP': 'Renaming group...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.EDITING_GROUP_DESCRIPTION':
    'Editing group description...',
  'OVERVIEW_CARD_MUTATION_MESSAGE.DELETING_GROUP': 'Deleting group...',
  'OVERVIEW_CARD.HOMEPAGE_LABEL': 'Published',
  'PAGE_DROPDOWN_MENU.EDIT_TITLE_ITEM': 'Edit title',
  'PAGE_DROPDOWN_MENU.UNPUBLISH_ITEM': 'Unpublish page',
  'PAGE_DROPDOWN_MENU.PAGE_ACCESS_ITEM': 'Share',
  'PAGE_DROPDOWN_MENU.TABLE_OF_CONTENTS_ITEM': 'Table of contents',
  'PAGE_DROPDOWN_MENU.DELETE_PAGE_ITEM': 'Delete page',
  'PAGE_DROPDOWN_MENU.DUPLICATE_PAGE_ITEM': 'Duplicate',
  'PAGE_DROPDOWN_MENU.MOVE_PAGE_ITEM': 'Move',

  'EDIT_PAGE_MODAL.HEADER_TEXT': 'Edit page title',
  'EDIT_PAGE_MODAL.LABEL_TEXT': 'Page title',
  'EDIT_PAGE_MODAL.PLACEHOLDER_TEXT': 'Enter a title for your page',

  'DUPLICATE_PAGE_MODAL.HEADER_TEXT': 'Duplicate page',
  'DUPLICATE_PAGE_MODAL.LABEL_TEXT': 'Page title',
  'DUPLICATE_PAGE_MODAL.PLACEHOLDER_TEXT': 'Enter a title for your page',
  'DUPLICATE_PAGE_MODAL.BUTTON_SAVE': 'Duplicate page',
  'DUPLICATE_PAGE_MODAL.COPY': ' (copy)',

  'SHARE_MODAL.HEADER_TEXT': 'Share {title}',

  'DELETE_PAGE_MODAL.HEADER_TEXT': 'Delete page',
  'DELETE_PAGE_MODAL.CONTENT_TEXT':
    'Are you sure you want to delete "{title}". Deleting this page will also delete all the content inside. This action cannot be undone.',
  'DELETE_PAGE_MODAL.BUTTON_TEXT': 'Delete page',

  'HEIGHT_DROPDOWN.DEFAULT': 'Default',
  'HEIGHT_DROPDOWN.MEDIUM': 'Medium',
  'HEIGHT_DROPDOWN.LARGE': 'Large',
  'HEIGHT_DROPDOWN.BUTTON_TEXT': 'Height',

  'ASSET_DETAIL_OVERLAY.BUTTON_TEXT': 'Open in Asset Bank',

  'DROPPABLE_PAGE_AREA.ADD_PAGE_BUTTON_TEXT': 'Add page',

  'PAGE_HEADER.PUBLISH_BUTTON_TEXT': 'Publish',
  'PAGE_HEADER.PUBLISHING_BUTTON_TEXT': 'In progress...',
  'PAGE_HEADER.PUBLISHED': 'Published',
  'PAGE_HEADER.DRAFT': 'Draft',
  'PAGE_HEADER.CREATED': 'Created {date}',
  'PAGE_HEADER.UPDATED': 'Updated {date}',
  'PAGE_HEADER.SHARE_BUTTON_TEXT': 'Copy link to page',

  'WIDGETS_CONSTANTS.COLLECTION_ASSET_COUNT':
    '{count, plural, one {{count} asset} other {{count} assets}}',
  'WIDGETS_CONSTANTS.DOWNLOAD_COLLECTION': 'Download collection',
  'WIDGETS_CONSTANTS.DOWNLOAD_COLLECTION_DISABLED':
    'This collection can not be downloaded due to limited permissions.',
  'WIDGETS_CONSTANTS.DOWNLOAD_ASSET': 'Download asset',
  'WIDGETS_CONSTANTS.DOWNLOAD_ASSET_DISABLED':
    'This asset can not be downloaded due to limited permissions.',
  'WIDGETS_CONSTANTS.DOWNLOADING_COLLECTION': 'Downloading...',
  'WIDGETS_CONSTANTS.COLLECTION_EXPAND': 'Show all',
  'WIDGETS_CONSTANTS.COLLECTION_MINIMIZE': 'Show less',
  'WIDGETS_CONSTANTS.PRIVATE_COLLECTION_TITLE': 'No preview available',
  'WIDGETS_CONSTANTS.PRIVATE_COLLECTION_BUTTON': 'View collection',
  'WIDGETS_CONSTANTS.PRIVATE_COLLECTION_SUBTITLE':
    'We are unable to show a preview of the collection due to limited permissions, please try using the link below.',
  'WIDGETS_CONSTANTS.COLLECTION_ASSET_ARCHIVED': 'Archived',
  'WIDGETS_CONSTANTS.COLLECTION_ASSET_LIMITED': 'Limited',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_GRID': 'Fixed',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_MASONRY': 'Masonry',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_ASSET_TITLE': 'Show title',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_ASSET_TYPE': 'Show type',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_ASSET_DOWNLOAD': 'Asset download',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_COLLECTION_DOWNLOAD':
    'Collection download',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_ASSET_REDIRECTION':
    'Redirect to asset',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_COLLECTION_REDIRECTION':
    'Redirect to collection',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_LAYOUT_GRID_BUTTON': 'Layout grid',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_ASSET_PREVIEW_BUTTON': 'Asset preview',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_DOWNLOAD_BUTTON': 'Download settings',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_REDIRECT_BUTTON':
    'Redirection settings',
  'WIDGETS_CONSTANTS.COLLECTION_SETTINGS_ASSETS_SHOWN_BUTTON':
    'Assets displayed',
  'WIDGETS_CONSTANTS.DELETE_WIDGET_BUTTON': 'Delete',
  'WIDGETS_CONSTANTS.MOVE_WIDGET_BUTTON': 'Move widget',
  'PAGE_HEADER_COLOR_PICKER.TOOLTIP_CONTENT': 'Background color',
  'WIDGETS_CONSTANTS.EMPTY_AUDIO_WIDGET': 'Empty audio widget',
  'WIDGETS_CONSTANTS.EMPTY_IMAGE_WIDGET': 'Empty image widget',
  'WIDGETS_CONSTANTS.EMPTY_VIDEO_WIDGET': 'Empty video widget',
  'WIDGETS_CONSTANTS.EMPTY_WIDGETS.YOUTUBE': 'Empty YouTube widget',
  'WIDGETS_CONSTANTS.EMPTY_WIDGETS.VIMEO': 'Empty Vimeo widget',
  'WIDGETS_CONSTANTS.EMPTY_WIDGETS.FIGMA': 'Empty Figma widget',
  'WIDGETS_CONSTANTS.MEDIA_TITLE': 'Media',
  'WIDGETS_CONSTANTS.FORMATTING_TITLE': 'Formatting',
  'WIDGETS_CONSTANTS.EMBED_TITLE': 'Embed',
  'WIDGETS_CONSTANTS.COLORS_TITLE': 'Colors',

  'PAGE_HEADER_MENU.REMOVE_IMAGE_ACTION': 'Remove image',

  'PAGE_TABLE_OF_CONTENTS.PLACEHOLDER_TITLE': 'Table of contents',
  'PAGE_TABLE_OF_CONTENTS.EDIT_BUTTON_TEXT': 'Edit',

  'SIDEBAR_PAGE_ITEM.DRAFT_TOOLTIP_CONTENT': 'Draft \u2022 {time}',
  'SIDEBAR_PAGE_ITEM.DRAFT_BADGE_CONTENT': 'Draft',

  'ADD_SECTION_BUTTON.ENABLED_TOOLTIP_CONTENT': 'Add section',
  'ADD_SECTION_BUTTON.DISABLED_TOOLTIP_CONTENT': 'You reached the limit',

  'SECTION_COLOR_PICKER.TOOLTIP_CONTENT': 'Background color',

  'SECTION_LIST.NO_SECTION_PLACEHOLDER': 'Add your first section',

  'DUPLICATE_GUIDE_MODAL.HEADER_TEXT': 'Duplicate guide',
  'DUPLICATE_GUIDE_MODAL.LABEL_TEXT': 'Guide title',
  'DUPLICATE_GUIDE_MODAL.PLACEHOLDER_TEXT': 'Enter a title for your guide',
  'DUPLICATE_GUIDE_MODAL.BUTTON_SAVE': 'Duplicate guide',
  'DUPLICATE_GUIDE_MODAL.HEADER_TEXT_PAGE': 'Duplicate landing page',
  'DUPLICATE_GUIDE_MODAL.LABEL_TEXT_PAGE': 'Landing page title',
  'DUPLICATE_GUIDE_MODAL.LABEL_TEXT_HOMEPAGE': 'Homepage title',
  'DUPLICATE_GUIDE_MODAL.PLACEHOLDER_TEXT_PAGE': 'Enter a title for your page',
  'DUPLICATE_GUIDE_MODAL.PLACEHOLDER_TEXT_HOMEPAGE':
    'Enter a title for your homepage',
  'DUPLICATE_GUIDE_MODAL.BUTTON_SAVE_PAGE': 'Duplicate landing page',
  'DUPLICATE_GUIDE_MODAL.BUTTON_SAVE_HOMEPAGE': 'Duplicate homepage',
  'DUPLICATE_GUIDE_MODAL.COPY': ' (copy)',

  'SECTION_MENU.COLUMN_TEXT':
    '{count, plural, one {{count} column} other {{count} columns}}',
  'SECTION_MENU.DUPLICATE_TOOLTIP_CONTENT_ENABLED': 'Duplicate section',
  'SECTION_MENU.DUPLICATE_TOOLTIP_CONTENT_DISABLED':
    'Duplicating would exceed max amount of widgets',
  'SECTION_MENU.MOVE_UP_TOOLTIP_CONTENT': 'Move up',
  'SECTION_MENU.MOVE_DOWN_TOOLTIP_CONTENT': 'Move down',
  'SECTION_MENU.DELETE_SECTION_TOOLTIP_CONTENT': 'Delete section',

  'DELETE_SECTION_MODAL.HEADER_TEXT': 'Delete section',
  'DELETE_SECTION_MODAL.CONTENT_TEXT':
    'Are you sure you want to delete this section?',

  'TYPOGRAPHY_EXPANDED.NAME': 'Name',
  'TYPOGRAPHY_EXPANDED.FONT_FAMILY': 'Font family',
  'TYPOGRAPHY_EXPANDED.FONT_STYLE': 'Font style',
  'TYPOGRAPHY_EXPANDED.FONT_SIZE': 'Font size',
  'TYPOGRAPHY_EXPANDED.LETTER_SPACING': 'Letter spacing',
  'TYPOGRAPHY_EXPANDED.LINE_HEIGHT': 'Line height',
  'TYPOGRAPHY_EXPANDED.EDIT_BUTTON_TEXT': 'Edit',
  'TYPOGRAPHY_EXPANDED.INPUT_PLACEHOLDER_TEXT': 'Typography Name',
  'TYPOGRAPHY_EXPANDED.CANCEL_BUTTON_TEXT': 'Cancel',
  'TYPOGRAPHY_EXPANDED.SAVE_BUTTON_TEXT': 'Save',
  'TYPOGRAPHY_EXPANDED.IN_PIXELS': 'in px',
  'TYPOGRAPHY_EXPANDED.DEFAULT_COLOR': 'Default color',

  'ASSET_PICKER_DROPDOWN.CHOOSE_FROM_DAM_ITEM': 'Choose from assets',
  'ASSET_PICKER_DROPDOWN.CHOOSE_FROM_DESKTOP_ITEM': 'Upload image',
  'ASSET_PICKER_DROPDOWN.MAX_UPLOAD_SIZE': 'Max {size}MB',
  'ASSET_PICKER_DROPDOWN.PERMISSION_LABEL':
    'You need the following permissions:',
  'ASSET_PICKER_DROPDOWN.PERMISSION_1': 'Upload assets',
  'ASSET_PICKER_DROPDOWN.PERMISSION_2': 'Mark assets as public',
  'HEADER.VIEW_MODE_SWITCH_TEXT': 'View',
  'HEADER.VIEW_MODE_SWITCH_TEXT_PAGE': 'View',
  'HEADER.SWITCH_TOOLTIP_TEXT': 'Upload still in progress…',
  'HEADER.EDIT_GUIDE_BUTTON_TEXT': 'Edit',
  'HEADER.EDIT_GUIDE_BUTTON_TEXT_PAGE': 'Edit',
  'HEADER.SHARE_GUIDE_BUTTON_TEXT': 'Copy link to guide',

  'MODAL_BUTTON.SIMPLE_MODAL_TITLE': 'No Internet connection',
  'MODAL_BUTTON.SIMPLE_MODAL_COPY': 'You are offline. Trying to reconnect...',
  'MODAL_BUTTON.SIMPLE_MODAL_BUTTON_TEXT': 'Refresh',

  'SHARE_MODAL_BUTTON.HEADER_TEXT': 'Share {title}',

  'THEMESET.BACK_BUTTON_TEXT': 'Back to Themes',
  'THEMESET.LINK_TO_COLORS_TEXT': 'Colors',
  'THEMESET.LINK_TO_FONTS_TEXT': 'Fonts & Typography',
  'THEMESET.LINK_TO_UI_TEXT': 'Look and feel - Guides',
  'THEMESET.LOOK AND FEEL_TEXT': 'Look and feel',
  'THEMESET.LINK_TO_PAGE_UI_TEXT': 'Look and feel - Pages',
  'THEMESET.LINK_TO_WIDGET_UI_TEXT': 'Look and feel - Widgets',
  'THEMESET.PAGE_HEADER_TEXT_COLOR': 'Text color',
  'THEMESET.PAGE_SECTION_TITLE': 'Section',
  'THEMESET.ANCHOR_LINK_TEXT': 'Anchor link & Table of contents',
  'THEMESET.GUIDE_PROPERTIES': 'Properties',
  'THEMESET.PROPERTIES_PUBLIC_GUIDES': 'Public Guides',
  'THEMESET.PROPERTIES_PUBLIC_PAGES': 'Public landing pages',
  'THEMESET.PROPERTIES_PAGE_HEADER': 'Main navigation bar',
  'THEMESET.PROPERTIES_UPLOAD_LOGO_SUBTEXT': 'Recommended height 40px',
  'THEMESET.PROPERTIES_CUSTOM_LOGO': 'Custom logo',
  'THEMESET.PROPERTIES_CUSTOM_LOGO_SUBTEXT': 'Guide header',
  'THEMESET.PROPERTIES_ADD_LOGO': 'Add logo',
  'THEMESET.PROPERTIES_NAVIGATION': 'Navigation',
  'THEMESET.PROPERTIES_NAVIGATION_SUBTEXT': 'On guide header in view mode',
  'THEMESET.PROPERTIES_NAVIGATION_BACK_BUTTON': 'Back button',
  'THEMESET.PROPERTIES_NAVIGATION_BROWSER_BACK': 'Browser back',
  'THEMESET.PROPERTIES_NAVIGATION_OVERVIEW': 'Overview',
  'THEMESET.PROPERTIES_NAVIGATION_CUSTOM_LINK': 'Custom link',
  'THEMESET_COLOR_PICKER.DEFAULTED_COLOR':
    'No custom color set. Applying default from theme.',

  'THEMESET.PROPERTIES_LOGO': 'Logo',
  'THEMESET.PROPERTIES_LOGIN': 'Login',

  'IMAGE_WITH_PROGRESS.IMG_ALT': 'Uploading',

  'RICH_TEXT_COLOR_PICKER.IMG_ALT': 'Text Color',

  'AUDIO_WIDGET.ERROR_MESSAGE':
    'Your browser does not support the audio element.',

  'COLLECTION_WIDGET_ACTIONS.DROPDOWN_SECTION_TITLE': 'Show up to...',
  'COLLECTION_WIDGET_ACTIONS.NUMBER_OF_ASSETS': 'assets',

  'COLOR_SWATCH.COLOR_NAME_PLACEHOLDER': 'Color name',

  'COLOR_SWATCH_CODE.TOOLTIP_INITIAL_LABEL': 'Copy {label} value',
  'COLOR_SWATCH_CODE.TOOLTIP_SUCCESS_LABEL': 'Copied to clipboard!',
  'COLOR_SWATCH_CODE.TOOLTIP_FAILURE_LABEL': 'Failed to copy to clipboard',
  'COLOR_SWATCH_CODE.INPUT_PLACEHOLDER': 'Enter code',

  'CUSTOM_COLOR_SWATCH_KEY.INPUT_PLACEHOLDER': 'Enter name',

  'IMAGE_WIDGET.EMPTY_BUTTON_TEXT': 'Choose from assets',
  'IMAGE_WIDGET.PLACEHOLDER_FILE_TITLE': 'Generating image',
  'IMAGE_WIDGET.FILE_SELECTOR_BUTTON_TEXT': 'Upload image',

  'IMAGE_WIDGET_ACTIONS.PREVIEW_ITEM': 'Open preview',
  'IMAGE_WIDGET_ACTIONS.NO_ACTION_ITEM': 'No action',
  'IMAGE_WIDGET_ACTIONS.ADD_LINK': 'Add link',
  'IMAGE_WIDGET_ACTIONS.EDIT_LINK': 'Edit link',

  'RICHTEXT.TOC_TOOLTIP_DEFAULT_TEXT': 'Click title to copy link',
  'RICHTEXT.TOC_TOOLTIP_SUCCESS_TEXT': 'Link copied!',
  'RICHTEXT.TOC_TOOLTIP_FAILURE_TEXT': 'Failure!',

  'SPACER_WIDGET_ACTIONS.NONE_ITEM': 'None',

  'TABLE_WIDGET_SKELETON.CONTROL_TOOLTIP_LABEL_COLUMNS':
    'Cannot add more columns',
  'TABLE_WIDGET_SKELETON.CONTROL_TOOLTIP_LABEL_ROW': 'Cannot add more rows',
  'TABLE_WIDGET_SKELETON.DELETE_COLUMN_DISABLED': 'Cannot delete last column',
  'TABLE_WIDGET_SKELETON.DELETE_COLUMN_ENABLED': 'Delete column',
  'TABLE_WIDGET_SKELETON.ADD_COLUMN_DISABLED': 'Cannot add more columns',
  'TABLE_WIDGET_SKELETON.DELETE_ROW_DISABLED': 'Cannot delete last row',
  'TABLE_WIDGET_SKELETON.DELETE_ROW_ENABLED': 'Delete row',
  'TABLE_WIDGET_SKELETON.ADD_ROW_DISABLED': 'Cannot add more rows',

  'TEXT_WIDGET.PLACEHOLDER': 'Start typing your story',

  'TITLE_WIDGET.PLACEHOLDER': 'Enter a title',

  'VIDEO_WIDGET.VIDEO_ERROR': 'Your browser does not support video playback.',

  'DELETE_WIDGET_MODAL.HEADER_TEXT': 'Delete widget',
  'DELETE_WIDGET_MODAL.CONTENT_TEXT':
    'Are you sure you want to delete this widget?',

  'WIDGET_MENU.LIMIT_TOOLTIP_CONTENT':
    "You've reached the limit of widgets in this page",
  'WIDGET_MENU.TOOLBAR_HELPER_TEXT': 'Add new widget',
  'WIDGET_MENU.TOOLBAR_HELPER_TEXT_DISABLED': 'Limit of widgets reached',
  'WIDGET_MENU.SEARCH_PLACEHOLDER': 'Search',

  'WIDGETS_CONSTANTS.TEXT': 'Text',
  'WIDGETS_CONSTANTS.TEA': 'Text',
  'WIDGETS_CONSTANTS.MEDIA': 'Image',
  'WIDGETS_CONSTANTS.COLLECTION': 'Collection',
  'WIDGETS_CONSTANTS.TABLE': 'Table',
  'WIDGETS_CONSTANTS.COLOR_PALETTE': 'Color palette',
  'WIDGETS_CONSTANTS.VIDEO': 'Video',
  'WIDGETS_CONSTANTS.AUDIO': 'Audio',
  'WIDGETS_CONSTANTS.SPACING_DIVIDER': 'Spacing divider',
  'WIDGETS_CONSTANTS.BUTTON': 'Button',
  'WIDGETS_CONSTANTS.CARD': 'Card',
  'WIDGETS_CONSTANTS.YOUTUBE': 'YouTube',
  'WIDGETS_CONSTANTS.VIMEO': 'Vimeo',
  'WIDGETS_CONSTANTS.FIGMA': 'Figma',
  'WIDGETS_CONSTANTS.NEW': 'New',

  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.HEADER_TEXT': 'Theme details',
  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.TITLE_LABEL': 'Name',
  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.TITLE_PLACEHOLDER': 'Enter a name',
  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.DESCRIPTION_LABEL': 'Description',
  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.DESCRIPTION_PLACEHOLDER':
    'Enter a description',
  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.COLOR_LABEL': 'Color',
  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.COLOR_PLACEHOLDER': 'Enter hex code',
  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.LABEL_OPTIONAL': '(Optional)',
  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.LIMIT_EXCEEDED': 'Limit exceeded',
  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.CANCEL_BUTTON': 'Cancel',
  'EDIT_THEMESET_DETAILS_MODAL_CONTENT.SAVE_CHANGES_BUTTON': 'Save',

  'NOTIFICATION.SAVE_LINK_TO_CLIPBOARD': 'Link copied to clipboard',
  'NOTIFICATION.GROUP_DELETED_SUCCESS': 'Group successfully deleted',
  'NOTIFICATION.CREATE_GUIDE_SUCCESS_NOTIFICATION':
    'Guide created successfully',
  'TEXT_COLOR_PICKER.TEXT_COLOR': 'Text color',
  'NOTIFICATION.COLLECTION_DOWNLOAD_FAILURE':
    "Collection couldn't be downloaded.\nPlease try again",
  'NOTIFICATION.COLLECTION_DOWNLOAD_SUCCESS':
    'Collection successfully downloaded',
  'NOTIFICATION.ASSET_IN_COLLECTION_DOWNLOAD_FAILURE':
    "Asset couldn't be downloaded.\nPlease try again",
  'NOTIFICATION.ASSET_IS_NOT_DOWNLOADABLE': 'This asset is not downloadable.',
  'NOTIFICATION.ASSET_IN_COLLECTION_DOWNLOAD_SUCCESS':
    'Asset successfully downloaded',

  'NOTIFICATION.DUPLICATING_PAGE_SUCCESS_MESSAGE':
    'Page duplicated successfully',
  'NOTIFICATION.DUPLICATING_GUIDE_SUCCESS_MESSAGE': 'Successfully duplicated',
  'NOTIFICATION.DELETING_GUIDE_SUCCESS_MESSAGE': 'Successfully deleted',
  'NOTIFICATION.DELETING_GROUP_SUCCESS_NOTIFICATION':
    'Group deleted successfully',
  'NOTIFICATION.CREATING_GROUP_SUCCESS_NOTIFICATION':
    'Group created successfully',
  'NOTIFICATION.ADDING_GUIDE_TO_GROUP_SUCCESS_NOTIFICATION':
    'Guide added to group successfully',
  'NOTIFICATION.REMOVING_GUIDE_FROM_GROUP_SUCCESS_NOTIFICATION':
    'Guide removed from group successfully',
  'NOTIFICATION.MOVING_PAGE_TO_GUIDE_SUCCESS_NOTIFICATION':
    'Succesfully duplicated page into {guideTitle}.',
  'NOTIFICATION.TARGETED_PAGE_DUPLICATION_SUCCESS_NOTIFICATION':
    'Successfully duplicated page.',
  'NOTIFICATION.TARGETED_PAGE_CREATION_SUCCESS_NOTIFICATION':
    'Successfully created page.',

  'SIDEBAR_TABLE_OF_CONTENTS.TABLE_OF_CONTENTS': 'Table of contents',

  'GUIDE_CARD.SUBTITLE': 'Edited {date}',
  'GROUP_CARD.SUBTITLE': 'Edited {date}',

  'DATETIME.JUST_NOW': 'just now',

  'THEMESET_TYPO_PICKER.FONT_FAMILY': 'Font family',
  'THEMESET_TYPO_PICKER.FONT_STYLE': 'Font style',

  'THEMESET_GUIDE_UI.NAVBAR_OPTION': 'Guide header',
  'THEMESET_GUIDE_UI.SIDEBAR_OPTION': 'Guide sidebar',
  'THEMESET_GUIDE_UI.PAGE_HEADER_OPTION': 'Page header',

  'THEMESET_GUIDE_UI_NAVIGATION_BAR.BACKGROUND_COLOR': 'Background color',
  'THEMESET_GUIDE_UI_NAVIGATION_BAR.BORDER_COLOR': 'Border color',
  'THEMESET_GUIDE_UI_NAVIGATION_BAR.GUIDE_TITLE': 'Guide title',
  'THEMESET_GUIDE_UI_NAVIGATION_BAR.TEXT_COLOR': 'Text color',

  'THEMESET_GUIDE_UI_SIDEBAR.BACKGROUND_COLOR': 'Background color',
  'THEMESET_GUIDE_UI_SIDEBAR.BORDER_COLOR': 'Border color',
  'THEMESET_GUIDE_UI_SIDEBAR.NORMAL_TEXT': 'Normal text',
  'THEMESET_GUIDE_UI_SIDEBAR.CHAPTER': 'Chapter',
  'THEMESET_GUIDE_UI_SIDEBAR.PAGE': 'Page',
  'THEMESET_GUIDE_UI_PREVIEW.PAGE_ACTIVE': 'Page active',
  'THEMESET_GUIDE_UI_SIDEBAR.TABLE_OF_CONTENTS': 'Table of contents',
  'THEMESET_GUIDE_UI_SIDEBAR.TABLE_OF_CONTENTS_ACTIVE':
    'Table of contents active',
  'THEMESET_GUIDE_UI_SIDEBAR.HOVER_TEXT': 'Hover text',
  'THEMESET_GUIDE_UI_SIDEBAR.ACTIVE_TEXT': 'Active text',
  'THEMESET_GUIDE_UI_SIDEBAR.HOVER_BACKGROUND_COLOR': 'Hover background',
  'THEMESET_GUIDE_UI_SIDEBAR.ACTIVE_BACKGROUND_COLOR': 'Active background',
  'THEMESET_GUIDE_UI_SIDEBAR.NORMAL_ACCENT_COLOR': 'Normal accent color',
  'THEMESET_GUIDE_UI_SIDEBAR.HOVER_ACCENT_COLOR': 'Hover accent color',
  'THEMESET_GUIDE_UI_SIDEBAR.ACTIVE_ACCENT_COLOR': 'Active accent color',
  'THEMESET_GUIDE_UI_SIDEBAR.DISCARD_CHANGES_BUTTON': 'Discard changes',
  'THEMESET_GUIDE_UI_SIDEBAR.SAVE_CHANGES_BUTTON': 'Save changes',

  'THEMESET_WIDGET_UI.BUTTON_TITLE': 'Button widget',
  'THEMESET_WIDGET_UI.BUTTON_DEFAULT_COLORS': 'Default colors',
  'THEMESET_WIDGET_UI.BUTTON_HOVER_COLORS': 'Hover colors',
  'THEMESET_WIDGET_UI.BUTTON_BORDER': 'Border',
  'THEMESET_WIDGET_UI.BUTTON_BACKGROUND': 'Background',
  'THEMESET_WIDGET_UI.BUTTON_TEXT': 'Text',

  'THEMESET_WIDGET_UI.CARD_TITLE': 'Card widget',
  'THEMESET_WIDGET_UI.CARD_TITLE_COLOR': 'Title',
  'THEMESET_WIDGET_UI.CARD_DESCRIPTION_COLOR': 'Description',
  'THEMESET_WIDGET_UI.CARD_BORDER_COLOR': 'Border',

  'GUIDE_SAVING_STATUS.NOT_SAVED': 'Unsaved changes',
  'GUIDE_SAVING_STATUS.SAVED': 'Changes are saved',
  'GUIDE_SAVING_STATUS.SAVING': 'Saving changes',
  'GUIDE_SAVING_STATUS.UPDATED': 'Updated',

  'GUIDE_INSPECTOR_PANEL.GUIDE_TITLE': 'Title',
  'GUIDE_INSPECTOR_PANEL.THEME_SET': 'Theme',
  'GUIDE_INSPECTOR_PANEL.COVER_IMAGE': 'Cover image',
  'GUIDE_INSPECTOR_PANEL.GUIDE_COVER_SUBTEXT': 'Recommended 512 x 320',
  'GUIDE_INSPECTOR_PANEL.GUIDE_COVER_TITLE': 'Content',
  'GUIDE_INSPECTOR_PANEL.GUIDE_FEATURED': 'Featured guide',
  'GUIDE_INSPECTOR_PANEL.SHARE_TAB': 'Share',
  'GUIDE_INSPECTOR_PANEL.DUPLICATE_TAB': 'Duplicate',

  'PAGE_INSPECTOR.SET_AS_HOMEPAGE': 'Set as homepage',
  'PAGE_INSPECTOR.HEADER_TYPE_TITLE': 'Header',
  'PAGE_INSPECTOR.HEADER_HEIGHT_TITLE': 'Height',
  'PAGE_INSPECTOR.DROPDOWN_COMPACT_VIEW': 'Select',
  'PAGE_INSPECTOR.PERSONAL_UPLOAD': 'Upload',
  'PAGE_INSPECTOR.HEADER_IMAGE_TITLE': 'Background image',

  'PAGE_INSPECTOR.HEADER_TITLE': 'Content',
  'PAGE_INSPECTOR.TITLE_SECTION': 'Title',
  'PAGE_INSPECTOR.CHAPTER_TITLE': 'Chapter',
  'PAGE_INSPECTOR.PAGE_TITLE': 'Page',
  'PAGE_INSPECTOR.HEADER_SUBTEXT_S': 'Recommended height: 200px',
  'PAGE_INSPECTOR.HEADER_SUBTEXT_M': 'Recommended height: 400px',
  'PAGE_INSPECTOR.HEADER_SUBTEXT_L': 'Recommended height: 600px',
  'PAGE_INSPECTOR.HEADER_TEXT_COLOR_TITLE': 'Text color',
  'PAGE_INSPECTOR.HEADER_TEXT_COLOR_DEFAULT': 'Default theme',
  'PAGE_INSPECTOR.HEADER_BACKGROUND_TITLE': 'Color',
  'PAGE_INSPECTOR.HEADER_COLOR_TITLE': 'Title color',
  'PAGE_INSPECTOR.TOC_TITLE': 'Table of contents',
  'PAGE_INSPECTOR.TOC_SIDEBAR_TITLE': 'Sidebar',
  'PAGE_INSPECTOR.TOC_SIDEBAR_DESCRIPTION': 'Show table of contents in sidebar',
  'PAGE_INSPECTOR.TOC_PAGE_TITLE': 'Page',
  'PAGE_INSPECTOR.TOC_PAGE_DESCRIPTION': 'Show table of contents in page',

  'SECTION_INSPECTOR.SECTION_TITLE': 'Section',
  'SECTION_INSPECTOR.BACKGROUND_COLOR_TITLE': 'Background',
  'SECTION_INSPECTOR.BACKGROUND_SOLID_COLOR': 'Solid Color',
  'SECTION_INSPECTOR.BACKGROUND_IMAGE': 'Image',
  'SECTION_INSPECTOR.LAYOUT_TITLE': 'Layout',

  'WIDGETS_INSPECTOR.COLLECTION_TITLE': 'Collections',
  'WIDGETS_INSPECTOR.COLLECTION_LAYOUT_TITLE': 'Layout grid',
  'WIDGETS_INSPECTOR.COLLECTION_GRID_OPTION': 'Grid',
  'WIDGETS_INSPECTOR.COLLECTION_MASONRY_OPTION': 'Masonry',
  'WIDGETS_INSPECTOR.COLLECTION_ASSET_COUNT_TITLE': 'Assets shown',
  'WIDGETS_INSPECTOR.COLLECTION_ASSET_COUNT': '{count} assets',
  'WIDGETS_INSPECTOR.COLLECTION_ASSET_TITLE': 'Asset',
  'WIDGETS_INSPECTOR.COLLECTION_ASSET_OPTION_TITLE': 'Title',
  'WIDGETS_INSPECTOR.COLLECTION_ASSET_OPTION_TYPE': 'Type',
  'WIDGETS_INSPECTOR.COLLECTION_DOWNLOAD_TITLE': 'Download',
  'WIDGETS_INSPECTOR.COLLECTION_ASSET_DOWNLOAD': 'Asset download',
  'WIDGETS_INSPECTOR.COLLECTION_COLLECTION_DOWNLOAD': 'Collection download',
  'WIDGETS_INSPECTOR.COLLECTION_REDIRECTIONS_TITLE': 'Redirections',
  'WIDGETS_INSPECTOR.COLLECTION_REDIRECTION_ASSET': 'Redirect to asset',
  'WIDGETS_INSPECTOR.COLLECTION_REDIRECTION_COLLECTION':
    'Redirect to collection',

  'WIDGETS_INSPECTOR.COLOR_TITLE': 'Color palette',
  'WIDGETS_INSPECTOR.COLOR_PALETTE_WIDGET_COLOR_NAME': 'Name',
  'WIDGETS_INSPECTOR.COLOR_PALETTE_WIDGET_COLOR_KEY': 'Mode',
  'WIDGETS_INSPECTOR.COLOR_PALETTE_WIDGET_COLOR_VALUE': 'Value',
  'WIDGETS_INSPECTOR.COLOR_SPACES_TITLE': 'Modes',

  'WIDGETS_INSPECTOR.IMAGE_TITLE': 'Image',
  'WIDGETS_INSPECTOR.IMAGE_ACTION_TITLE': 'Action',
  'WIDGETS_INSPECTOR.IMAGE_NEW_TAB': 'Open in new tab',

  'WIDGETS_INSPECTOR.TEA_ALIGNMENT_TITLE': 'Alignment',
  'WIDGETS_INSPECTOR.TEA_SCRIPT_TITLE': 'Script',
  'WIDGETS_INSPECTOR.TEA_INSERT_TITLE': 'Insert',

  'WIDGETS_INSPECTOR.SPACER_TITLE': 'Spacing divider',
  'WIDGETS_INSPECTOR.LINE_TITLE': 'Line',
  'WIDGETS_INSPECTOR.HEIGHT_TITLE': 'Height',

  'WIDGETS_INSPECTOR.SELECT_WIDGET_TEXT':
    'Select a widget to customize styling.',
  'WIDGETS_INSPECTOR.NO_STYLING_WIDGET_TEXT':
    'This widget has no styling options at the moment.',

  'GUIDE_OWNER.CREATED_BY': 'Created by {author}',
  'GUIDE_OWNER.CREATED_BY_YOU': 'Created by you',
  'GUIDE_OWNER.AUTHOR_UNKNOWN': 'Created by Former user (deleted)',

  'FONT_SETTINGS.ADD_FONT': '+ Add font',
  'FONT_SETTINGS.ERROR_STATUS_MESSAGE': 'There was an error!',
  'FONT_SETTINGS.SUCCESS_STATUS_MESSAGE': 'The Font was saved successfully!',
  'FONT_SETTINGS.FONT_MANAGEMENT': 'Font Management',
  'FONT_SETTINGS.SAVE_BUTTON': 'Save',

  'OVERVIEW_CARD.DEFAULT': 'Default',

  'DELETE_THEMESET_MODAL.HEADER_TEXT': 'Delete theme',
  'DELETE_THEMESET_MODAL.CONTENT_TEXT':
    'Are you sure you want to permanently delete this theme? Any guides with this theme applied will switch back to the default one.',

  'THEMESET_COLORS.ADD_COLOR_BUTTON': 'Add color',
  'THEMESET_COLORS.EDIT_COLOR': 'Edit',
  'THEMESET_COLORS.EDIT_SAVE': 'Save',
  'THEMESET_COLORS.EDIT_CANCEL': 'Cancel',
  'THEMESET_COLORS.COLOR_PLACEHOLDER': 'Pick a color',
  'THEMESET_COLORS.LABEL_PLACEHOLDER': 'Color name',
  'THEMESET_COLORS.LIST_TITLE': 'Theme colors',
  'TYPOGRAPHY_THEMESET.NOTIFICATION_ERROR_TITLE': 'Unable to save changes',
  'TYPOGRAPHY_THEMESET.NOTIFICATION_ERROR_BODY':
    'Your changes could not be saved because of a server error. Please try again.',

  'CREATE_THEMESET_MODAL_CONTENT.CREATE_BUTTON': 'Create theme',

  'EDIT_MODAL.BUTTON_SAVE': 'Save',

  'GUIDE_UI_THEMESET.UNSAVED_CHANGES_MESSAGE':
    'You have unsaved changes to your settings. If you leave the page before saving, your changes will be lost. Are you sure you want to leave this page?',

  'NOTIFICATION.GUIDE_LIMIT_HEADER': 'Your guide is close to the size limit',
  'NOTIFICATION.GUIDE_LIMIT_CONTENT':
    "This guide has reached {size}% of the maximum size allowed. Once this happens, you won't be able to add any more content to the guide.",
  'MAX_SIZE_MODAL.ACTION_TEXT': 'OK, thank you',
  'MAX_SIZE_MODAL.HEADER_TEXT': "Can't add any more content",
  'MAX_SIZE_MODAL.CONTENT_TEXT':
    'The guide has reached the maximum size allowed. To add to this guide, please remove part of the existing content first.',
  'NOTIFICATION.OFFLINE_MESSAGE': 'You are offline. Trying to connect...',
  'NOTIFICATION.WS_OFFLINE_MESSAGE':
    'Connection was interrupted so some changes might not be saved. Please check your work to prevent data loss',
  'NOTIFICATION.BAD_VIDEO_MESSAGE':
    'Something went wrong with the video conversion. Please try again later.',
  'NOTIFICATION.SUBSCRIPTION_TIMED_OUT_MESSAGE':
    'Something went wrong. We cannot guarantee that your work is saved.',
  'NOTIFICATION.CONFIRMATION_TIMED_OUT_MESSAGE': `Changes couldn't be saved`,
  'NOTIFICATION.GENERIC_ERROR_MESSAGE':
    'Something went wrong. Please refresh and try again.',
  'NOTIFICATION.TEMPORARY_ERROR_MESSAGE':
    'Something went wrong. Please try again.',
  'NOTIFICATION.OUTDATED_GUIDE_MESSAGE':
    'Someone else has edited this guide. Refresh to see the last changes.',
  'NOTIFICATION.FAILED_TO_UPLOAD_ASSET_MESSAGE':
    "You don't have permission, please contact your admin",
  'NOTIFICATION.FAILED_TO_UPLOAD_ASSET_TITLE': 'Failed to upload',
  'NOTIFICATION.REFRESH_BUTTON_TEXT': 'Refresh',
  'NOTIFICATION.VISIT_PAGE_BUTTON_TEXT': 'Visit page',
  'NOTIFICATION.VISIT_GUIDE_BUTTON_TEXT': 'Visit',
  'NOTIFICATION.CLOSE_BUTTON_TEXT': 'Close',
  'NOTIFICATION.DUPLICATING_PAGE_MESSAGE': 'Duplicating page...',
  'NOTIFICATION.PUBLISH_PAGE_SUCCESS_MESSAGE': 'Page published successfully',
  'NOTIFICATION.UNPUBLISH_PAGE_SUCCESS_MESSAGE':
    'Page unpublished successfully',
  'NOTIFICATION.UPLOAD_ERROR_NOTIFICATION_TITLE': 'File {filename} is too big',
  'NOTIFICATION.UPLOAD_ERROR_NOTIFICATION_DESCRIPTION':
    'Please upload a file that is smaller than {maxSize}MB',
  'NOTIFICATION.IMAGE_WIDGET_CUSTOM_URL_SUCCESS': 'Link added successfully.',
  'GUIDE_MOVE_PERMISSION_WARNING_MODAL.HEADER_TEXT': 'Move guide',
  'GUIDE_MOVE_PERMISSION_WARNING_MODAL.CONTENT_TEXT':
    'Everyone from "{groupTitle}" will also have access to this guide unless you specify otherwise.',
  'GUIDE_MOVE_PERMISSION_WARNING_MODAL.SECONDARY_BUTTON': 'Cancel',
  'GUIDE_MOVE_PERMISSION_WARNING_MODAL.PRIMARY_BUTTON': 'Move',
  'GUIDE_REMOVE_PERMISSION_WARNING_MODAL.HEADER_TEXT': 'Remove guide',
  'GUIDE_REMOVE_PERMISSION_WARNING_MODAL.CONTENT_TEXT':
    'Everyone from "{groupTitle}" will lose access to this guide unless it is directly shared with them.',
  'GUIDE_REMOVE_PERMISSION_WARNING_MODAL.SECONDARY_BUTTON': 'Cancel',
  'GUIDE_REMOVE_PERMISSION_WARNING_MODAL.PRIMARY_BUTTON': 'Remove',
  'UNPUBLISHED.EMPTY_GUIDE_HEADER_TEXT': 'No published content',
  'UNPUBLISHED.EMPTY_PAGE_HEADER_TEXT': 'Unpublished content',
  'UNPUBLISHED.GUIDE_PARAGRAPH_TEXT':
    "It seems like this guide doesn't have published content to show.",
  'UNPUBLISHED.PAGE_PARAGRAPH_TEXT':
    'It seems like this page has not been published yet.',
  'UNPUBLISHED.EDIT_TEXT': 'Click on the button below to edit the guide.',

  'GUIDE.UNTITLED_CHAPTER': 'Untitled chapter',
  'GUIDE.UNTITLED_PAGE': 'Untitled page',

  'SCROLL_TO_TOP_BUTTON.TOOLTIP': 'Back to top',

  'IMAGE_WIDGET_CUSTOM_URL_MODAL.ADD_LINK': 'Add link',
  'IMAGE_WIDGET_CUSTOM_URL_MODAL.EDIT_LINK': 'Edit link',
  'IMAGE_WIDGET_CUSTOM_URL_MODAL.SAVE_BUTTON': 'Save',
  'IMAGE_WIDGET_CUSTOM_URL_MODAL.LABEL_TEXT': 'Type or paste your link',
  'IMAGE_WIDGET_CUSTOM_URL_MODAL.PLACEHOLDER_TEXT': 'Type or paste link',
  'IMAGE_WIDGET_CUSTOM_URL_MODAL.OPEN_NEW_TAB': 'Open in new tab',

  'SEARCH.SEARCH_TITLE': 'Search Results',
  'SEARCH.INPUT_PLACEHOLDER': 'Search',
  'SEARCH.MORE_RESULTS_BUTTON': 'Show more results',
  'SEARCH.TOTAL_RESULTS': 'Showing {results} of {totalHits} results',
  'SEARCH.TYPE_FILTER_ALL': 'All results',
  'SEARCH.TYPE_FILTER_WIDGETS': 'Widgets',
  'SEARCH.TYPE_FILTER_PAGES': 'Pages',
  'SEARCH.TYPE_FILTER_GUIDES': 'Guides',
  'SEARCH.TYPE_FILTER_LANDING_PAGES': 'Landing pages',
  'SEARCH.TYPE_FILTER_GROUPS': 'Groups',
  'SEARCH.TIME_FILTER_ANY_TIME': 'Any time',
  'SEARCH.TIME_FILTER_TODAY': 'Today',
  'SEARCH.TEXT_WIDGET': 'Text',
  'SEARCH.COLOR_WIDGET': 'Color Palette',
  'SEARCH.CARD_WIDGET': 'Card',
  'SEARCH.TIME_FILTER_LAST_SEVEN_DAYS': 'Last 7 days',
  'SEARCH.TIME_FILTER_LAST_MONTH': 'Last 30 days',
  'SEARCH.TIME_FILTER_LAST_TWO_MONTHS': 'Last 2 months',
  'SEARCH.TIME_FILTER_LAST_YEAR': 'Last year',
  'SEARCH.NO_RESULTS_TITLE': 'No results found',
  'SEARCH.NO_RESULTS_TEXT':
    'There were no results that meet your search criteria.',
  'SEARCH.NO_RESULTS_BUTTON': 'Clear search',
  'SEARCH.WIDGET_LAST_EDITED': 'Edited {date}',
  'SEARCH.INPUT_DROPDOWN_ENTER': 'Press enter to search',
  'SEARCH.INPUT_DROPDOWN_RECENT_SEARCHES': 'Recent Searches',
  'SEARCH.ERROR_NOTIFICATION': 'Something went wrong. Please try again.',
  'SEARCH.ERROR_NOTIFICATION_BUTTON': 'Try again',
  'EMPTY_GUIDE.TITLE': "Let's go!",
  'EMPTY_GUIDE.SUBTITLE':
    'Start creating content by adding your first chapter and page.',

  'SECTION_INSPECTOR.SECTION_TEMPLATE_TITLE': 'Select Preset',
  'SECTION_INSPECTOR.SECTION_WIDTH': 'Section width',
  'SECTION_INSPECTOR.SECTION_WIDTH_SMALL': 'S',
  'SECTION_INSPECTOR.SECTION_WIDTH_MEDIUM': 'M',
  'SECTION_INSPECTOR.SECTION_WIDTH_LARGE': 'L',
  'SECTION_INSPECTOR.SECTION_WIDTH_XLARGE': 'XL',

  'SECTION_INSPECTOR.SECTION_PADDING': 'Padding',
  'SECTION_INSPECTOR.SECTION_PADDING_NONE': '∅',
  'SECTION_INSPECTOR.SECTION_PADDING_SMALL': 'S',
  'SECTION_INSPECTOR.SECTION_PADDING_MEDIUM': 'M',
  'SECTION_INSPECTOR.SECTION_PADDING_LARGE': 'L',

  'SECTION_INSPECTOR.SECTION_HEIGHT': 'Section height',
  'SECTION_INSPECTOR.WIDGET_ALIGNMENT': 'Alignment',
  'SECTION_INSPECTOR.WIDGET_ALIGNMENT_TOP': 'Top',
  'SECTION_INSPECTOR.WIDGET_ALIGNMENT_CENTER': 'Center',
  'SECTION_INSPECTOR.WIDGET_ALIGNMENT_BOTTOM': 'Bottom',
  'SECTION_INSPECTOR.VERTICAL_PADDING': 'Vertical padding',
  'SECTION_INSPECTOR.HORIZONTAL_PADDING': 'Horizontal padding',

  'WIDGET_MENU.ADD_SECTION_TITLE': 'New section',
  'WIDGET_MENU.ADD_SECTION_BOTTOM': 'Blank section',
  'WIDGET_MENU.ADD_SECTION_TEMPLATE': 'Section templates',

  'SECTION_INSPECTOR.SECTION_CONTENT_SPACING': 'Spacing',
  'SECTION_INSPECTOR.SECTION_CONTENT_SPACING_NONE': '∅',
  'SECTION_INSPECTOR.SECTION_CONTENT_SPACING_SMALL': 'S',
  'SECTION_INSPECTOR.SECTION_CONTENT_SPACING_MEDIUM': 'M',
  'SECTION_INSPECTOR.SECTION_CONTENT_SPACING_LARGE': 'L',
  'SECTION_INSPECTOR.SECTION_CONTENT_SPACING_XLARGE': 'XL',

  'SECTION_INSPECTOR.COLUMN_GAP': 'Column gap',
  'SECTION_INSPECTOR.SECTION_COLUMN_GAP_NONE': '∅',
  'SECTION_INSPECTOR.SECTION_COLUMN_GAP_SMALL': 'S',
  'SECTION_INSPECTOR.SECTION_COLUMN_GAP_MEDIUM': 'M',
  'SECTION_INSPECTOR.SECTION_COLUMN_GAP_LARGE': 'L',
  'SECTION_INSPECTOR.SECTION_SIZE_TITLE': 'Size',
  'SECTION_INSPECTOR.WIDGET_TITLE': 'Widget',
  'SECTION_INSPECTOR.SECTION_WIDGET_TITLE': 'Section Settings',
  'SECTION_INSPECTOR.SECTION_WIDGET_SUBTITLE': 'Applies to all widgets',
  'WIDGET_INSPECTOR.WIDGET_WIP':
    'We’re working on adding more features to this widget.',
  'WIDGET_INSPECTOR.EMPTY_AUDIO_WIDGET_BUTTON': 'Select audio asset',
  'WIDGET_INSPECTOR.EMPTY_VIDEO_WIDGET_BUTTON': 'Select video asset',
  'WIDGET_INSPECTOR.VIDEO_CONTROLS_TOGGLE': 'Controls',
  'WIDGET_INSPECTOR.VIDEO_MUTED_TOGGLE': 'Muted',
  'WIDGET_INSPECTOR.VIDEO_AUTPLAY_MUTED_TOOLTIP': 'Autoplayed videos are muted',
  'WIDGET_INSPECTOR.VIDEO_AUTOPLAY_TOGGLE': 'Autoplay',
  'WIDGET_INSPECTOR.VIDEO_LOOP_TOGGLE': 'Loop',
  'WIDGET_INSPECTOR.CLEAR_VIDEO_BUTTON': 'Clear video',
  'WIDGET_INSPECTOR.CLEAR_IMAGE_BUTTON': 'Remove image',
  'WIDGET_INSPECTOR.CLEAR_AUDIO_BUTTON': 'Clear audio',
  'WIDGET_INSPECTOR.SHOW_DETAILS_BUTTON': 'Show details',
  'WIDGET_INSPECTOR.FIGMA_CONTROLS_TOGGLE': 'Controls',
  'WIDGET_INSPECTOR.FIGMA_FOOTER_TOGGLE': 'Footer',
  'WIDGET_INSPECTOR.FIGMA_THEME_TITLE': 'Theme',
  'WIDGET_INSPECTOR.FIGMA_SYSTEM_THEME': 'System',
  'WIDGET_INSPECTOR.FIGMA_LIGHT_THEME': 'Light',
  'WIDGET_INSPECTOR.FIGMA_DARK_THEME': 'Dark',

  'WIDGET_INSPECTOR.BUTTON_TEXT': 'Button label',
  'WIDGET_INSPECTOR.BUTTON_PROPERTIES': 'Customize',
  'WIDGET_INSPECTOR.BUTTON_CUSTOM_LINK': 'Custom Link',
  'WIDGET_INSPECTOR.BUTTON_CUSTOM_CSS': 'Custom CSS',
  'WIDGET_INSPECTOR.BUTTON_LINK': 'Custom link',
  'WIDGET_INSPECTOR.BUTTON_SIZE_SMALL': 'S',
  'WIDGET_INSPECTOR.BUTTON_SIZE_MEDIUM': 'M',
  'WIDGET_INSPECTOR.BUTTON_SIZE_LARGE': 'L',
  'WIDGET_INSPECTOR.BUTTON_SHAPE_SQUARE': 'Square',
  'WIDGET_INSPECTOR.BUTTON_SHAPE_ROUNDED': 'Rounded',
  'WIDGET_INSPECTOR.BUTTON_SHAPE_PILL': 'Pill',
  'WIDGET_INSPECTOR.BUTTON_STYLE': 'Style',
  'WIDGET_INSPECTOR.BUTTON_ALIGNMENT': 'Widget settings',
  'WIDGET_INSPECTOR.BUTTON_ALIGNMENT_SUBTEXT': 'Applies to all buttons',

  'WIDGET_INSPECTOR.BUTTON_COLOR_BASE': 'Default colors',
  'WIDGET_INSPECTOR.BUTTON_COLOR_HOVER': 'Hover colors',
  'WIDGET_INSPECTOR.BUTTON_COLOR_OUTLINE': 'Border',
  'WIDGET_INSPECTOR.BUTTON_COLOR_BACKGROUND': 'Background',
  'WIDGET_INSPECTOR.BUTTON_COLOR_TEXT': 'Text',
  'WIDGET_INSPECTOR.BUTTON_ADD_BUTTON': 'Add button',
  'WIDGET_INSPECTOR.BUTTON_REMOVE_BUTTON': 'Remove button',

  'WIDGET_INSPECTOR.BUTTON_LINK_PLACEHOLDER': 'http://',
  'WIDGET_INSPECTOR.BUTTON_LINK_INVALID_URL': 'Invalid URL',
  'WIDGET_INSPECTOR.BUTTON_NOT_ENTERPRISE':
    "Customizing the widget's styling with CSS is a feature exclusive to the Enterprise Tier. To access this capability, kindly reach out to your administrator.",
  'WIDGET_INSPECTOR.BUTTON_BORDER_RADIUS_LABEL': 'Type',
  'WIDGET_INSPECTOR.BUTTON_SIZE_LABEL': 'Size',
  'WIDGET_INSPECTOR.BUTTON_GAP': 'Spacing',
  'BUTTON_WIDGET.PLACEHOLDER': 'New Button',
  'WIDGET_INSPECTOR.CARD_CUSTOMIZE_ACCORDION': 'Customize',
  'WIDGET_INSPECTOR.CARD_CUSTOM_LINK_ACCORDION': 'Custom link',
  'WIDGET_INSPECTOR.CARD_GRID_SETTINGS_ACCORDION': 'Widget settings',
  'WIDGET_INSPECTOR.CARD_WIDTH': 'Width',
  'WIDGET_INSPECTOR.CARD_ALIGNMENT': 'Alignment',
  'WIDGET_INSPECTOR.CARD_GRID_SETTINGS_SUBTEXT': 'Applies to all cards',
  'WIDGET_INSPECTOR.CARD_IMAGE_SUBTEXT': 'Recommended aspect ratio 16:10',
  'WIDGET_INSPECTOR.CARD_ADD_CARD': 'Add card',
  'WIDGET_INSPECTOR.CARD_ALIGNMENT_LEFT': 'Left',
  'WIDGET_INSPECTOR.CARD_ALIGNMENT_CENTER': 'Center',
  'WIDGET_INSPECTOR.CARD_ALIGNMENT_RIGHT': 'Right',
  'WIDGET_INSPECTOR.CARD_ALIGNMENT_SPACE_BETWEEN': 'Space-between',
  'WIDGET_INSPECTOR.CARD_REMOVE_CARD': 'Remove card',
  'WIDGET_INSPECTOR.CARD_COLORS_ACCORDION': 'Colors',
  'WIDGET_INSPECTOR.CARD_COLOR_TITLE': 'Title',
  'WIDGET_INSPECTOR.CARD_COLOR_DESCRIPTION': 'Description',
  'WIDGET_INSPECTOR.CARD_COLOR_BORDER': 'Border',
  'EMPTY_PAGE.TITLE': 'This page has no content yet',
  'EMPTY_PAGE.SUBTITLE':
    'Start creating content for this page by switching to Edit mode.',
  'PAGE_HEADER.TOGGLE_INSPECTOR_PANEL_BUTTON_TEXT': 'Settings',
  'WIDGET_INSPECTOR.COLLECTION_TITLE_COLOR': 'Collection title',
  'WIDGET_INSPECTOR.COLLECTION_ASSET_COUNT_COLOR': 'Asset count',
  'WIDGET_INSPECTOR.COLLECTION_ASSET_TITLE_COLOR': 'Asset title',
  'WIDGET_INSPECTOR.COLLECTION_FONT_SIZE': 'Font size',
  'WIDGET_INSPECTOR.COLLECTION_FONT_COLOR': 'Color',
  'WIDGET_INSPECTOR.SPACER_WIDGET_PROPERTIES': 'Properties',
  'WIDGET_INSPECTOR.SPACER_WIDGET_DIVIDER_COLOR': 'Divider color',

  'HOMEPAGE_MODAL.HEADER_TEXT': 'Publish Homepage',
  'HOMEPAGE_MODAL.REPLACE_CONTENT_TEXT':
    'You will unpublish your current Homepage and replace it with the new one, making it accessible to all users. Do you want to proceed?',
  'HOMEPAGE_MODAL.CONTENT_TEXT':
    'You are about to publish a Homepage. This will automatically make it accessible to all users. Do you want to proceed?',
  'HOMEPAGE_MODAL.INFO_TEXT':
    'Targeted pages (if any) will need to be individually published.',
  'HOMEPAGE_MODAL.BUTTON_TEXT': 'Yes, publish',
  'HOMEPAGE_MODAL.CANCEL_TEXT': 'Cancel',
  'UNSET_HOMEPAGE_MODAL.HEADER_TEXT': 'Unpublish Homepage',
  'UNSET_HOMEPAGE_MODAL.CONTENT_TEXT':
    'This action will unpublish the Homepage (including targeted pages) and all users will land on the asset bank. Do you want to proceed?',
  'UNSET_HOMEPAGE_MODAL.INFO_TEXT':
    'Keep landing page published and accessible to all users.',
  'UNSET_HOMEPAGE_MODAL.BUTTON_TEXT': 'Yes, unpublish',
  'UNSET_HOMEPAGE_MODAL.CANCEL_TEXT': 'Cancel',
  'HOMEPAGE_NOTIFICATION.SET_SUCCESS_MESSAGE': 'Homepage published.',
  'HOMEPAGE_NOTIFICATION.UNSET_SUCCESS_MESSAGE': 'Homepage unpublished.',
  'TARGETED_PAGES_MODAL.HEADER_TEXT': 'Disable targeted pages',
  'TARGETED_PAGES_MODAL.CONTENT_TEXT':
    'All targeted pages will be unpublished. You can restore them anytime by re-enabling. Do you want to proceed?',
  'TARGETED_PAGES_MODAL.BUTTON_TEXT': 'Yes, disable',
  'TARGETED_PAGES_MODAL.CANCEL_TEXT': 'Cancel',

  'PAGE_TEMPLATE_MODAL.INPUT_LABEL': 'Title',
  'PAGE_TEMPLATE_MODAL.INPUT_PLACEHOLDER': 'Enter a title',
  'PAGE_TEMPLATE_MODAL.SELECT_TITLE': 'Select Template',
  'PAGE_TEMPLATE_MODAL.BLANK_TEMPLATE': 'Blank page',
  'PAGE_TEMPLATE_MODAL.HP_TEMPLATE_1': 'Homepage 1',
  'PAGE_TEMPLATE_MODAL.HP_TEMPLATE_2': 'Homepage 2',
  'PAGE_TEMPLATE_MODAL.GTM_TEMPLATE': 'Go-to-market Essentials',
  'PAGE_TEMPLATE_MODAL.PL_TEMPLATE': 'Product Launch',
  'PAGE_TEMPLATE_MODAL.BRAND_PORTAL': 'Brand portal',

  'SECTION_TEMPLATE_MODAL.HEADER_TITLE': 'Select section template',
  'SECTION_TEMPLATE_MODAL.ALL_CONTENT_TITLE': 'All templates',
  'SECTION_TEMPLATE_MODAL.BANNER_TITLE': 'Banner',
  'SECTION_TEMPLATE_MODAL.BODY_TITLE': 'Body',
  'SECTION_TEMPLATE_MODAL.FOOTER_TITLE': 'Footer',
  'SECTION_TEMPLATE_MODAL.NAVIGATION_TITLE': 'Navigation',
};
